import { Box, SkeletonText } from '@chakra-ui/react';

export default function GenericLoader() {
  return (
    <Box padding='6' bg='white'>
      <SkeletonText mt='4' noOfLines={4} spacing='4' skeletonHeight='2' />
    </Box>
  );
}
